var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.3,
    height: 27.3,
    viewBox: "0 0 27.3 27.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.45,37.65l-2.1-2.1L21.9,24,10.35,12.45l2.1-2.1L24,21.9,35.55,10.35l2.1,2.1L26.1,24,37.65,35.55l-2.1,2.1L24,26.1Z",
    transform: "translate(-10.35 -10.35)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.39bead8f98c76db26c25de1e2ccccb7b.svg";
export { ForwardRef as ReactComponent };